import { useEffect, useState } from 'react'
import { apiURL } from '../../../utilities/URLs'
import { customerData, CustomerDaysData } from '../../../utilities/CustomerData'
import { refreshAccessToken } from '../../../utilities/extensions'
import { useNavigate } from 'react-router-dom'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.module.css'

import '../../../css/Slider.css'

export default function DashboardChangeDays() {
  const navigate = useNavigate()
  const [fetchingCustomerDaysData, setFetchingCustomerDaysData] = useState(true)
  const [customerDaysData, setCustomerDaysData] = useState(new CustomerDaysData())
  const [updatingCustomerDays, setUpdatingCustomerDays] = useState(false)
  const [updatedCustomerDays, setUpdatedCustomerDays] = useState('')

  useEffect(() => {
    const handleGetCustomerDaysData = async () => {
      const customerDaysResponse = await fetch(`${apiURL}/api/getCustomerDays?leadId=${encodeURIComponent(customerData.customerLeadData.leadId)}&leadType=${encodeURIComponent(customerData.customerLeadData.leadType)}`, {
        headers: {
          'Authorization': customerData.accessToken
        }
      })
      const customerDaysData = await customerDaysResponse.json()
      setFetchingCustomerDaysData(false)
      if (customerDaysData.response.error) {
        if (customerDaysData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleGetCustomerDaysData() : navigate('/', { state: { expired: true } })
        } else
          console.error(customerDaysData.response.error)
      } else
        setCustomerDaysData(new CustomerDaysData(customerDaysData.response.customerDays))
    }

    handleGetCustomerDaysData()
  }, [])

  const handleDateChange = (date, index) => {
    if (date) {
      const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

      const year = utcDate.getUTCFullYear()
      const month = String(utcDate.getUTCMonth() + 1).padStart(2, '0')
      const day = String(utcDate.getUTCDate()).padStart(2, '0')
      const formattedDate = `${year}-${month}-${day}`

      setCustomerDaysData((prevDaysData) => ({
        ...prevDaysData,
        [`Day_${index + 1}_6b`]: formattedDate,
      }))
    }
  }

  const handleResubmitDays = async () => {
    setUpdatingCustomerDays(true)

    const form = new FormData
    form.append('customerDays', JSON.stringify({
      leadId: customerData.customerLeadData.leadId,
      leadType: customerData.customerLeadData.leadType,
      irsBalance: customerData.customerDocuments.irsBalance,
      customerDays: customerDaysData
    }))

    const updateCustomersDaysResponse = await fetch(`${apiURL}/api/updateCustomerDays`, {
      method: 'PUT',
      headers: {
        'Authorization': customerData.accessToken
      },
      body: form
    })
    const updateCustomerDaysData = await updateCustomersDaysResponse.json()
    setUpdatingCustomerDays(false)

    if (updateCustomerDaysData.response.error) {
      if (updateCustomerDaysData.response.error == 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleResubmitDays() : navigate('/', { state: { expired: true } })
      } else
        console.error(updateCustomerDaysData.response.error)
    } else {
      setUpdatedCustomerDays('Updated Days Successfully, Reloading Page...')
      setTimeout(() => {
        window.location.reload()
      }, 3000)
    }
  }

  return (
    <div className='shadow-full rounded-xl p-4 lg:w-full w-11/12 h-fit mt-10 flex flex-col bg-white mb-10 items-center'>
      {fetchingCustomerDaysData ? (
        <div className='flex flex-row items-center justify-center gap-2'>
          <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
          <p>Fetching Days Data...</p>
        </div>
      ) : (
        <div className='flex flex-col items-center'>
          <div className='flex flex-col items-start gap-3 mb-10'>
            <p className='font-bold text-xl'>Sick Leave Tax Credit</p>
            <div className='w-full border-t border-gray-300'></div>
            <p className='text-gray-600 text-sm'>How many days were you unable to work due to government shutdowns, quarantine, isolation orders, and/or a COVID-19 diagnosis or symptoms?</p>
          </div>
          <div className='my-4'>
            <p className='mb-12 font-bold'>January 1, 2021, through March 31, 2021</p>
            <div className='relative flex items-center gap-4'>
              <span className='text-gray-700'>0 days</span>
              <input
                type='range'
                id='dateSlider'
                min='0'
                max='10'
                step='1'
                value={customerDaysData.Gov_January_1_2021}
                onChange={(e) =>
                  setCustomerDaysData((prevDaysData) => ({
                    ...prevDaysData,
                    Gov_January_1_2021: e.target.value,
                  }))
                }
                className='w-64 h-2 bg-gray-300 rounded-lg outline-none appearance-none slider-thumb'
                style={{
                  background: `linear-gradient(to right, #74be43 ${((customerDaysData.Gov_January_1_2021 / 10) * 100)}%, #ddd ${((customerDaysData.Gov_January_1_2021 / 10) * 100)}%)`,
                }}
              />
              <div className='absolute -top-8 left-[40%]'>
                <span className='bg-white text-gray-700 border border-gray-300 px-2 py-1 rounded-lg shadow-sm'>
                  {customerDaysData.Gov_January_1_2021} days
                </span>
              </div>
              <span className='text-gray-700'>10 days</span>
            </div>
          </div>
          <div className='my-4 mb-24'>
            <p className='mb-12 font-bold'>April 1, 2021, through September 30, 2021</p>
            <div className='relative flex items-center gap-4'>
              <span className='text-gray-700'>0 days</span>
              <input
                type='range'
                id='dateSlider'
                min='0'
                max='10'
                step='1'
                value={customerDaysData.Gov_April_1_2021}
                onChange={(e) =>
                  setCustomerDaysData((prevDaysData) => ({
                    ...prevDaysData,
                    Gov_April_1_2021: e.target.value,
                  }))
                }
                className='w-64 h-2 bg-gray-300 rounded-lg outline-none appearance-none slider-thumb'
                style={{
                  background: `linear-gradient(to right, #74be43 ${((customerDaysData.Gov_April_1_2021 / 10) * 100)}%, #ddd ${((customerDaysData.Gov_April_1_2021 / 10) * 100)}%)`,
                }}
              />
              <div className='absolute -top-8 left-[40%]'>
                <span className='bg-white text-gray-700 border border-gray-300 px-2 py-1 rounded-lg shadow-sm'>
                  {customerDaysData.Gov_April_1_2021} days
                </span>
              </div>
              <span className='text-gray-700'>10 days</span>
            </div>
          </div>
          <div className='flex flex-col items-start gap-3 mb-10'>
            <p className='font-bold text-xl'>Sick Leave Tax Credit</p>
            <div className='w-full border-t border-gray-300'></div>
            <p className='text-gray-600 text-sm'>How many days were you unable to work caring for: (1) anyone subject to government ordered or medically advised quarantine related to COVID-19, and/or (2) a child whose school or place of care was closed due to COVID-19?</p>
          </div>
          <div className='my-4'>
            <p className='mb-12 font-bold'>January 1, 2021, through March 31, 2021</p>
            <div className='relative flex items-center gap-4'>
              <span className='text-gray-700'>0 days</span>
              <input
                type='range'
                id='dateSlider'
                min='0'
                max='10'
                step='1'
                value={customerDaysData.Child_January_1_2021}
                onChange={(e) =>
                  setCustomerDaysData((prevDaysData) => ({
                    ...prevDaysData,
                    Child_January_1_2021: e.target.value,
                  }))
                }
                className='w-64 h-2 bg-gray-300 rounded-lg outline-none appearance-none slider-thumb'
                style={{
                  background: `linear-gradient(to right, #74be43 ${((customerDaysData.Child_January_1_2021 / 10) * 100)}%, #ddd ${((customerDaysData.Child_January_1_2021 / 10) * 100)}%)`,
                }}
              />
              <div className='absolute -top-8 left-[40%]'>
                <span className='bg-white text-gray-700 border border-gray-300 px-2 py-1 rounded-lg shadow-sm'>
                  {customerDaysData.Child_January_1_2021} days
                </span>
              </div>
              <span className='text-gray-700'>10 days</span>
            </div>
          </div>
          <div className='my-4 mb-24'>
            <p className='mb-12 font-bold'>April 1, 2021, through September 30, 2021</p>
            <div className='relative flex items-center gap-4'>
              <span className='text-gray-700'>0 days</span>
              <input
                type='range'
                id='dateSlider'
                min='0'
                max='10'
                step='1'
                value={customerDaysData.Child_April_1_2021}
                onChange={(e) =>
                  setCustomerDaysData((prevDaysData) => ({
                    ...prevDaysData,
                    Child_April_1_2021: e.target.value,
                  }))
                }
                className='w-64 h-2 bg-gray-300 rounded-lg outline-none appearance-none slider-thumb'
                style={{
                  background: `linear-gradient(to right, #74be43 ${((customerDaysData.Child_April_1_2021 / 10) * 100)}%, #ddd ${((customerDaysData.Child_April_1_2021 / 10) * 100)}%)`,
                }}
              />
              <div className='absolute -top-8 left-[40%]'>
                <span className='bg-white text-gray-700 border border-gray-300 px-2 py-1 rounded-lg shadow-sm'>
                  {customerDaysData.Child_April_1_2021} days
                </span>
              </div>
              <span className='text-gray-700'>10 days</span>
            </div>
          </div>
          <div className='flex flex-col items-start gap-3 mb-10'>
            <p className='font-bold text-xl'>2020/2021 Sick Leave Tax Credit: Confirmation of Dates Missed</p>
            <div className='w-full border-t border-gray-300'></div>
            <p className='text-gray-600 text-sm'>Please select up to ten (10) of the specific days you missed between January 1, 2021, and March 31, 2021, based upon your previous responses. Please note, missed days during this period may be applied to either your 2020 or 2021 credit.</p>
          </div>
          <div className='grid grid-cols-2 gap-x-4 mb-24'>
            {Array.from({ length: customerDaysData.Gov_January_1_2021 }, (_, index) => (
              <div key={index} className='flex flex-col gap-2 mb-4'>
                <p className='font-bold'>Day ({index + 1})</p>
                <DatePicker
                  selected={new Date(`${customerDaysData[`Day_${index + 1}_6b`]}T00:00:00`)}
                  onChange={(e) => handleDateChange(e, index)}
                  className={`border rounded-lg px-4 py-2 transition-colors duration-200 ease-in-out shadow-sm focus:outline-none focus:ring-2 bg-white text-gray-900 border-gray-300 focus:ring-blue-500`}
                  dateFormat='yyyy-MM-dd'
                  placeholderText='Click to select a date'
                  minDate={new Date(2021, 0, 1)}
                  maxDate={new Date(2021, 2, 31)}
                />
              </div>
            ))}
          </div>
          <div className='flex flex-col items-start gap-3 mb-10'>
            <p className='font-bold text-xl'>2021 Sick Leave Tax Credit: Confirmation of Dates Missed</p>
            <div className='w-full border-t border-gray-300'></div>
            <p className='text-gray-600 text-sm'>Please select up to ten (10) of the specific days you missed between April 1, 2021, and September 30, 2021, based upon your previous responses. You may choose any of the days you missed during this time.</p>
          </div>
          <div className='grid grid-cols-2 gap-x-4 mb-24'>
            {Array.from({ length: customerDaysData.Gov_April_1_2021 }, (_, index) => (
              <div key={index} className='flex flex-col gap-2 mb-4'>
                <p className='font-bold'>Day ({index + 1})</p>
                <DatePicker
                  selected={new Date(`${customerDaysData[`Day_${index + 1}_38b`]}T00:00:00`)}
                  onChange={(e) => handleDateChange(e, index)}
                  className={`border rounded-lg px-4 py-2 transition-colors duration-200 ease-in-out shadow-sm focus:outline-none focus:ring-2 bg-white text-gray-900 border-gray-300 focus:ring-blue-500`}
                  dateFormat='yyyy-MM-dd'
                  placeholderText='Click to select a date'
                  minDate={new Date(2021, 3, 1)}
                  maxDate={new Date(2021, 8, 30)}
                />
              </div>
            ))}
          </div>
          <div className='flex flex-col items-start gap-3 mb-10'>
            <p className='font-bold text-xl'>Family Leave Tax Credit</p>
            <div className='w-full border-t border-gray-300'></div>
            <p className='text-gray-600 text-sm'>How many days were you unable to work caring for: (1) anyone subject to government ordered or medically advised quarantine related to COVID-19, and/or (2) a child whose school or place of care was closed due to COVID-19?</p>
          </div>
          <div className='my-4'>
            <p className='mb-12 font-bold'>January 1, 2021, through March 31, 2021</p>
            <div className='relative flex items-center gap-4'>
              <span className='text-gray-700'>0 days</span>
              <input
                type='range'
                id='dateSlider'
                min='0'
                max='50'
                step='1'
                value={customerDaysData.Family_January_1_2021}
                onChange={(e) =>
                  setCustomerDaysData((prevDaysData) => ({
                    ...prevDaysData,
                    Family_January_1_2021: e.target.value,
                  }))
                }
                className='w-64 h-2 bg-gray-300 rounded-lg outline-none appearance-none slider-thumb'
                style={{
                  background: `linear-gradient(to right, #74be43 ${((customerDaysData.Family_January_1_2021 / 50) * 100)}%, #ddd ${((customerDaysData.Family_January_1_2021 / 50) * 100)}%)`,
                }}
              />
              <div className='absolute -top-8 left-[40%]'>
                <span className='bg-white text-gray-700 border border-gray-300 px-2 py-1 rounded-lg shadow-sm'>
                  {customerDaysData.Family_January_1_2021} days
                </span>
              </div>
              <span className='text-gray-700'>50 days</span>
            </div>
          </div>
          <div className='my-4'>
            <p className='mb-12 font-bold'>April 1, 2021, through September 30, 2021</p>
            <div className='relative flex items-center gap-4'>
              <span className='text-gray-700'>0 days</span>
              <input
                type='range'
                id='dateSlider'
                min='0'
                max='60'
                step='1'
                value={customerDaysData.Family_April_1_2021}
                onChange={(e) =>
                  setCustomerDaysData((prevDaysData) => ({
                    ...prevDaysData,
                    Family_April_1_2021: e.target.value,
                  }))
                }
                className='w-64 h-2 bg-gray-300 rounded-lg outline-none appearance-none slider-thumb'
                style={{
                  background: `linear-gradient(to right, #74be43 ${((customerDaysData.Family_April_1_2021 / 60) * 100)}%, #ddd ${((customerDaysData.Family_April_1_2021 / 60) * 100)}%)`,
                }}
              />
              <div className='absolute -top-8 left-[40%]'>
                <span className='bg-white text-gray-700 border border-gray-300 px-2 py-1 rounded-lg shadow-sm'>
                  {customerDaysData.Family_April_1_2021} days
                </span>
              </div>
              <span className='text-gray-700'>60 days</span>
            </div>
          </div>
          <button disabled={updatingCustomerDays} onClick={() => handleResubmitDays()} className={`rounded-md text-white h-10 w-40 mb-4 mt-24 ${updatingCustomerDays ? 'bg-gray-400' : 'bg-primaryColor hover:bg-primaryDarkColor transition duration-200'}`}>
            Resubmit Days
          </button>
          {updatingCustomerDays && (
            <div className='flex flex-row items-center justify-center gap-2'>
              <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] h-8 w-8 mt-4 mb-4'></div>
              <p>Updating Days...</p>
            </div>
          )}
          {updatedCustomerDays.length > 0 && (
            <p>{updatedCustomerDays}</p>
          )}
        </div>
      )}
    </div>
  )
}